import { Injectable, signal } from '@angular/core';

@Injectable( { providedIn: 'root' } )
export class MenuStateService {
    /** Stores the source component whenever a menu opens. */
    readonly menuOpened = signal<string | null>( null );

    notifyMenuOpened( source: string ): void {
        this.menuOpened.set( source );
    }
}
